import { makeStyles } from '@fluentui/react';

export const useStyles = makeStyles(() => ({
  flex50: {
    flex: 0.5,
  },
  flex25: {
    flex: 0.25,
  },
  margin20: { marginTop: 20, marginBottom: 20 },
  flex1: { flexGrow: 1 },
}));
